import { initLanguage } from "@/core/plugins/init-application";

initLanguage();

import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initElementPlus } from "@/core/plugins/element-plus";
import { initLanguageRouterLink } from "@/core/plugins/inline-language-router-link";
import "@/core/plugins/bootstrap-daterangepicker";
import { initSvgSprite } from "@/core/plugins/init-svg-sprite";

const app = createApp(App);

app.use(store);
app.use(router);

ApiService.init(app);
initInlineSvg(app);
initElementPlus(app);
initLanguageRouterLink(app);
initSvgSprite(app);

app.use(i18n);

app.mount("#app");
